export function captureOutboundLink(url, trackingObject = false) {
    window.dataLayer.push(
        {
            'hitType': 'event',
            'eventCategory': 'outbound',
            'eventAction': 'click',
            'eventLabel': url,
        }
    );

    if(trackingObject) {
        addTrackingObject(trackingObject.navigation, trackingObject.event)
    }

    window.open(url, '_blank');
}

export function addTrackingObject(nav = false, event = false) {
    let jsonTrackingScript = document.querySelector('.json-tracking-object')
    if(!jsonTrackingScript) {
        const scriptTag = document.createElement('script');
        scriptTag.setAttribute('type','application/json');
        scriptTag.setAttribute('class', 'json-tracking-object')
        document.head.appendChild(scriptTag);
        jsonTrackingScript = document.querySelector('.json-tracking-object')
    }
    const trackingObject = {
        pageData: {}
    }
    if(nav) {
        trackingObject.pageData.navigation = nav
    }
    if(event) {
        trackingObject.pageData.event = event
    }
    console.log(trackingObject)
    jsonTrackingScript.innerHTML = JSON.stringify(trackingObject)
}